<template>
    <el-container>
        <!-- <td-permission :permissions="permissionsView">
            <div slot="havePermission"> -->
        <el-aside class="aside-classify-tree">
            <el-header class="extdnd-group-aside-header-class">
                <span style="font-weight:bold">{{ $t('extendCommon.EXTEND_GROUP_MANAGE') }}</span>
            </el-header>
            <el-main style="height:auto">
                <!-- 加载扩展组单列表-->
                <td-single-list
                    ref="tdSingleList"
                    rowKey="sId"
                    :height="listHeight"
                    :hasDefaultSelection="true"
                    :hasPageMemory="true"
                    :lazyloading="true"
                    :hasAddElement="true"
                    :columnObj="columnObj"
                    @currentChange="selectionChange"
                    :operateColumn="operateColumn"
                    :hasOperational="true"
                    @addElement="btnAddGroup"
                    :interfaceName="interfaceName"
                ></td-single-list>
            </el-main>
        </el-aside>
        <!-- </div>
        </td-permission> -->
        <el-container>
            <el-header class="extdnd-group-container-header-class">
                <span style="font-weight:bold">{{ $t('extendCommon.BASIC_INFO') }}</span>
            </el-header>
            <el-main>
                <el-form :inline="true" :model="extendGroupFrom" ref="extendGroupFrom">
                    <el-form-item :label="$t('extendCommon.EXTEND_GROUP_FLG')" prop="sGroupFlg">
                        <td-input v-model="extendGroupFrom.sGroupFlg" :readonly="true"></td-input>
                    </el-form-item>
                    <el-form-item :label="$t('extendCommon.EXTEND_GROUP_NAME')" prop="sGroupName">
                        <td-input v-model="extendGroupFrom.sGroupName" :readonly="true"></td-input>
                    </el-form-item>
                    <el-form-item class="paddingLeft10">
                        <td-button type="button" @click="btnPreview">{{ $t('extendCommon.PREVIEW_PAGE') }} </td-button>
                    </el-form-item>
                </el-form>
                <el-row>
                    <el-col>
                        <td-button type="button" @click="btnAddGroupElement">{{ $t('extendCommon.ADD_EXTEND_ELEMENT') }} </td-button>
                        <td-button type="button" @click="btnBatchDelElement" :loading="batchDeleteLoading">{{ $t('extendCommon.DELETE_BATCH') }} </td-button>
                    </el-col>
                </el-row>
                <!-- 加载表格 -->
                <el-row>
                    <el-col>
                        <td-table
                            :columns="columns"
                            :dataSource="tableData"
                            rowKey="sId"
                            :hasPage="false"
                            @handleSizeChange="handleSizeChange"
                            @currentChange="currentChange"
                            ref="tableInfo"
                            @getSortData="getSortData"
                            :hasDraggable="true"
                        ></td-table>
                    </el-col>
                </el-row>
                <!-- 加载扩展组dialog -->
                <dialog-Group
                    v-if="dialogGroupVisible"
                    :isAddData="isAddData"
                    :dialogVisible="dialogGroupVisible"
                    :editItem="editGroupItem"
                    :title="title"
                    @groupDialogClose="groupDialogClose"
                    @updateTableNode="updateTableNode"
                    @addTableNode="addTableNode"
                ></dialog-Group>
                <!-- 加载扩展元素dialog -->
                <dialog-GroupElement
                    v-if="dialogGroupElementVisible"
                    :isAddData="isAddElementData"
                    :dialogVisible="dialogGroupElementVisible"
                    :editItem="editItem"
                    :groupId="groupId"
                    :title="title"
                    :maxExtendOrder="maxExtendOrder"
                    @elementDialogClose="elementDialogClose"
                    @callbackQuery="callbackQuery"
                ></dialog-GroupElement>
                <!-- 加载效果预览dialog -->
                <dialog-Preview
                    v-if="dialogPreviewVisible"
                    :dialogVisible="dialogPreviewVisible"
                    :title="title"
                    :groupFlg="groupFlg"
                    :groupElementValue="groupElementValue"
                    @previewDialogClose="previewDialogClose"
                ></dialog-Preview>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
import extendGroupApi from './assets/api.js';
import dialogGroupInfo from './components/dialogGroupInfo.vue';
import dialogGroupElementInfo from './components/dialogGroupElementInfo.vue';
import dialogPreviewInfo from './components/dialogPreviewInfo.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-Group': dialogGroupInfo,
        'dialog-GroupElement': dialogGroupElementInfo,
        'dialog-Preview': dialogPreviewInfo
    },
    created() {
        // this.listQuery();
    },
    data() {
        return {
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            maxExtendOrder: 1,
            listHeight: window.innerHeight - 245,
            addLoading: false,
            batchDeleteLoading: false,
            dialogGroupVisible: false,
            dialogGroupElementVisible: false,
            dialogPreviewVisible: false,
            isAddData: true, // 是否为添加数据
            isAddElementData: true, // 是否为添加扩展组元素数据
            editItem: '',
            editGroupItem: '',
            groupFlg: '', //扩展组标识
            groupId: '', //扩展组ID
            groupElementValue: {}, //扩展组元素值
            extendGroupFrom: {
                sId: '',
                sGroupName: '',
                sGroupFlg: ''
            },
            interfaceName: { query: '/extendManage/findExtendGroupTree', search: '/extendManage/findExtendGroupTree' },
            tableData: [],
            //单列表对象
            columnObj: {
                id: 'sId',
                prop: 'sName'
            },
            //单列表操作项
            operateColumn: {
                width: '95',
                align: 'center',
                render: (createElement, params) => {
                    return createElement('div', [
                        createElement('td-button', {
                            style: {
                                'background-image': 'url(' + window.config.treeIcon + window.vue.$store.state.skin + '/img/tree/edit.png' + ') ',
                                'background-repeat': 'no-repeat',
                                'background-color': 'transparent',
                                border: '0px',
                                'background-position': 'right',
                                'padding-top': '15px'
                            },
                            props: { permissions: this.permissionsEdit, size: 'mini' },
                            on: {
                                click: () => {
                                    this.btnEditGroup(params.row);
                                }
                            }
                        }),
                        createElement('td-button', {
                            style: {
                                'background-image': 'url(' + window.config.treeIcon + window.vue.$store.state.skin + '/img/tree/delete.png' + ') ',
                                'background-repeat': 'no-repeat',
                                'background-color': 'transparent',
                                border: '0px',
                                'background-position': 'center',
                                'padding-top': '15px'
                            },
                            props: { permissions: this.permissionsDel, size: 'mini' },
                            on: {
                                click: () => {
                                    this.btnDelGruop(params.row);
                                }
                            }
                        })
                    ]);
                }
            },
            columns: [
                {
                    prop: 'sElementName',
                    label: this.$t('extendCommon.EXTEND_ELEMENT'),
                    showOverflowTooltip: true,
                    render: (createElement, params) => {
                        return createElement('span', params.row.sElementName + '：' + params.row.sElementFlg);
                    }
                },
                {
                    prop: 'sViewName',
                    label: this.$t('extendCommon.SHOW_NAME'),
                    showOverflowTooltip: true
                },
                {
                    prop: 'sElementKey',
                    label: this.$t('extendCommon.ELEMENT_KEY'),
                    showOverflowTooltip: true
                },
                {
                    prop: 'iOrder',
                    align: 'center',
                    tableWidth: '90',
                    label: this.$t('extendCommon.SHOW_ORDER')
                },
                {
                    prop: 'iColNum',
                    label: this.$t('extendCommon.ELEMENT_LAYOUT'),
                    align: 'center',
                    tableWidth: '90',
                    render: (createElement, params) => {
                        let rowName = this.$t('extendCommon.A_ROW');

                        if (params.row.iColNum === 12) {
                            rowName = this.$t('extendCommon.B_ROW');
                        }
                        if (params.row.iColNum === 8) {
                            rowName = this.$t('extendCommon.C_ROW');
                        }
                        if (params.row.iColNum === 6) {
                            rowName = this.$t('extendCommon.D_ROW');
                        }
                        return createElement('span', rowName);
                    }
                },
                {
                    prop: 'iHidden',
                    label: this.$t('extendCommon.ELEMENT_HIDDEN'),
                    align: 'center',
                    tableWidth: '80',
                    render: (createElement, params) => {
                        let rowName = '';
                        switch (Number(params.row.iHidden)) {
                            case 0:
                                rowName = this.$t('extendCommon.IS_TRUE');
                                break;
                            case 1:
                                rowName = this.$t('extendCommon.DENY');
                        }
                        return createElement('span', rowName);
                    }
                },
                {
                    prop: 'iNeeded',
                    label: this.$t('extendCommon.ELEMENT_NOT_NULL'),
                    align: 'center',
                    tableWidth: '80',
                    render: (createElement, params) => {
                        let rowName = this.$t('extendCommon.IS_TRUE');

                        if (Number(params.row.iNeeded) === 1) {
                            rowName = this.$t('extendCommon.DENY');
                        }
                        return createElement('span', rowName);
                    }
                },

                {
                    prop: '',
                    label: this.$t('extendCommon.OPERATE'),
                    tableWidth: '90',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnEditGroupElement(params.row);
                                        }
                                    }
                                },
                                this.$t('extendCommon.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsDel, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.deleteGroupElement(params.row);
                                        }
                                    }
                                },
                                this.$t('extendCommon.DELETE')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    methods: {
        //选择事件
        selectionChange(currentRow) {
            if (currentRow == null) {
                return;
            }
            this.groupId = currentRow.sId;
            this.extendGroupFrom.sId = currentRow.sId;
            this.extendGroupFrom.sGroupFlg = currentRow.sGroupFlg;
            this.extendGroupFrom.sGroupName = currentRow.sName;
            this.callbackQuery();
        },
        //效果预览
        btnPreview() {
            this.groupFlg = this.extendGroupFrom.sGroupFlg;
            if (this.groupFlg === window.tdExtend.common.extendGroupRootId) {
                this.$message({ showClose: true, message: this.$t('extendError.ERROR_PLEASE_GROUP'), type: 'warning' });
                return;
            }
            this.title = 'extendCommon.PREVIEW_PAGE'; // 标题

            let content = {
                groupFlg: this.groupFlg
            };
            extendGroupApi.queryExtendValue(content, response => {
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extendManage/queryExtendValue', response.data.statusMessage);
                    this.submitLoading = false;
                    return;
                }
                if (!this.$util.isEmpty(response.data.content)) {
                    this.groupElementValue = JSON.parse(response.data.content);
                }

                this.dialogPreviewVisible = true;
            });
        },
        //添加扩展组
        btnAddGroup() {
            this.title = 'extendCommon.ADD_EXTEND_GROUP'; // 标题
            this.isAddData = true;
            this.dialogGroupVisible = true;
        },
        //修改扩展组
        btnEditGroup(row) {
            this.title = 'extendCommon.EDIT_EXTEND_GROUP'; // 标题
            this.isAddData = false;
            this.dialogGroupVisible = true;
            this.editGroupItem = row;
        },
        //删除扩展组
        btnDelGruop(row) {
            this.$confirm(this.$t('extendCommon.DELETE_INFO_TIPS'), this.$t('extendCommon.TIPS'), {
                confirmButtonText: window.vue.$t('extendCommon.CONFIRM'),
                cancelButtonText: window.vue.$t('extendCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = {
                        sId: row.sId
                    };
                    extendGroupApi.deleteExtendGroup(param, response => {
                        if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                            return;
                        }
                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('extendManage/deleteExtendGroup', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('extendCommon.DELETE_SUCCESS'), type: 'success' });
                        this.$refs.tdSingleList.updateTableData('delete', row.sId);
                    });
                })
                .catch(() => {
                    // this.$message.info(this.$t('common.ADD_FAIL'))
                    // this.$log.error('extendInfo/btnDelete---- Fail')
                });
        },
        //添加扩展组元素
        btnAddGroupElement() {
            this.title = 'extendCommon.ADD_EXTEND_GROUP_ELEMENT'; // 标题
            this.isAddElementData = true;
            let param = {
                groupId: this.extendGroupFrom.sId
            };
            extendGroupApi.getMaxExtendOrder(param, response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extendManage/getMaxExtendOrder', response.data.statusMessage);
                    return;
                }
                this.maxExtendOrder = response.data.count + 1;
                this.dialogGroupElementVisible = true;
            });
        },
        // 编辑扩展组元素
        btnEditGroupElement(row) {
            this.editItem = row;
            this.title = 'extendCommon.EDIT_EXTEND_GROUP_ELEMENT';
            this.isAddElementData = false;
            this.dialogGroupElementVisible = true;
        },

        // 删除扩展组元素
        deleteGroupElement(row) {
            this.$confirm(this.$t('extendCommon.DELETE_INFO_TIPS'), this.$t('extendCommon.TIPS'), {
                confirmButtonText: window.vue.$t('extendCommon.CONFIRM'),
                cancelButtonText: window.vue.$t('extendCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = this.getDeleteParam(row);
                    extendGroupApi.deleteGroupElement(JSON.stringify(param), response => {
                        if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                            return;
                        }
                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('extendManage/deleteGroupElement', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('extendCommon.DELETE_SUCCESS'), type: 'success' });
                        this.callbackQuery();
                    });
                })
                .catch(() => {
                    // this.$message.info(this.$t('common.ADD_FAIL'))
                    // this.$log.error('extendInfo/btnDelete---- Fail')
                });
        },
        // 批量删除
        btnBatchDelElement() {
            this.batchDeleteLoading = true;
            let items = this.$refs.tableInfo.getSelectAllRows();
            if (items == null || items.length === 0) {
                this.$message({ showClose: true, message: this.$t('extendCommon.PLEASE_SELECT'), type: 'warning' });
                this.batchDeleteLoading = false;
                return;
            }
            this.$confirm(this.$t('extendCommon.DELETE_INFO_TIPS'), this.$t('extendCommon.TIPS'), {
                confirmButtonText: this.$t('extendCommon.CONFIRM'),
                cancelButtonText: this.$t('extendCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = this.getDeleteParam();
                    extendGroupApi.deleteGroupElement(JSON.stringify(param), response => {
                        if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                            this.batchDeleteLoading = false;
                            return;
                        }
                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('extendManage/deleteGroupElement', response.data.statusMessage);
                            this.batchDeleteLoading = false;
                            return;
                        }
                        this.batchDeleteLoading = false;
                        this.$message({ showClose: true, message: this.$t('extendCommon.DELETE_SUCCESS'), type: 'success' });
                        this.callbackQuery();
                    });
                })
                .catch(() => {
                    this.batchDeleteLoading = false;
                });
        },
        // 获取删除参数
        getDeleteParam(row) {
            let deleteParam = {
                sGroupId: this.extendGroupFrom.sId,
                recordIdList: []
            };
            if (this.$util.isEmpty(row)) {
                // 批量删除
                let items = this.$refs.tableInfo.getSelectAllRows();
                for (let i = 0; i < items.length; i++) {
                    deleteParam.recordIdList.push(items[i].sId);
                }
            } else {
                // 单个删除
                deleteParam.recordIdList.push(row.sId);
            }
            return deleteParam;
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.listQuery();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.listQuery();
        },
        // 回调查询
        callbackQuery() {
            this.currentPage = 1;
            this.listQuery();
        },
        // 查询数据
        listQuery() {
            var param = {
                sGroupId: this.extendGroupFrom.sId
            };
            extendGroupApi.listGroupElementInfo(JSON.stringify(param), response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.$log.error('extendManage/listGroupElementInfo', response);
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extendManage/listGroupElementInfo', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
            });
        },

        // 编辑节点回显到单列表
        updateTableNode(tableData) {
            this.$refs.tdSingleList.updateTableData('modify', tableData);
        },
        // 添加节点回显到单列表
        addTableNode(tableData) {
            this.$refs.tdSingleList.updateTableData('add', tableData);
        },
        //获取排序后的表格数据，并更新数据库
        getSortData(oldIndex, newIndex, formatData) {
            for (let i = 0; i < formatData.length; i++) {
                formatData[i].iOrder = i + 1;
            }
            extendGroupApi.updateSortInfo(JSON.stringify(formatData), response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.$log.error('extendManage/updateSortInfo', response);
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extendManage/updateSortInfo', response.data.statusMessage);
                    return;
                }
            });
        },
        // 关闭dialogGroupVisible页面
        groupDialogClose() {
            this.dialogGroupVisible = false;
        },
        // 关闭dialogGroupElementVisible页面
        elementDialogClose() {
            this.dialogGroupElementVisible = false;
        },
        // 关闭dialogPreviewVisible页面
        previewDialogClose() {
            this.dialogPreviewVisible = false;
        }
    }
};
</script>
<style></style>
